import CreditCardBanner from 'components/CreditCard/CreditCardBanner/CreditCardBanner';
import { withCreditCardBannerProps } from 'viewModel/content/creditCards/creditCardBanner/withCreditCardBannerProps';

export default withCreditCardBannerProps(CreditCardBanner);
